import { useEffect } from "react";

/**
 * Page par ek `<script type="application/ld+json">` (rulebook §4 — Product/Offer schema).
 * `data` null ho to kuch nahi; unmount par tag hat jaata hai.
 * Note: CRA client-side render hai — Google JS chala kar ise padh leta hai;
 * prerender (react-snap) Phase 4 me alag ticket.
 */
const useJsonLd = (id: string, data: Record<string, unknown> | null) => {
  useEffect(() => {
    const elId = `ld-${id}`;
    let el = document.getElementById(elId) as HTMLScriptElement | null;
    if (!data) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = elId;
      document.head.appendChild(el);
    }
    el.text = JSON.stringify(data);
    return () => {
      const cur = document.getElementById(elId);
      if (cur) cur.remove();
    };
  }, [id, data]);
};

export default useJsonLd;
